
import React from 'react';
import { ArrowRight, MessageSquare } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Link } from 'react-router-dom';
import { useNavigationUtils } from '@/hooks/useNavigationUtils';

const CtaSection = () => {
  const { getWhyFutureLevelPath } = useNavigationUtils();

  return (
    <section className="py-32 bg-gradient-to-b from-[#0A0A0A] to-[#090911] relative overflow-hidden">
      {/* Animated background elements */}
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute inset-0">
          {[...Array(6)].map((_, i) => (
            <div 
              key={i}
              className="absolute rounded-full bg-purple-600/10 blur-3xl"
              style={{
                top: `${Math.random() * 100}%`,
                left: `${Math.random() * 100}%`,
                width: `${Math.random() * 40 + 10}vw`,
                height: `${Math.random() * 40 + 10}vw`,
                opacity: Math.random() * 0.3,
                transform: 'translate(-50%, -50%)',
                animation: `pulse ${Math.random() * 15 + 5}s infinite alternate ease-in-out`,
              }}
            ></div>
          ))}
        </div>
      </div>
      
      <div className="container mx-auto px-4 relative z-10">
        <div className="max-w-4xl mx-auto text-center">
          <div className="mb-10">
            <h2 className="text-4xl md:text-5xl font-bold font-future text-white mb-6">
              Bereit, Ihre Marketingstrategie mit KI auf das nächste Level zu bringen?
            </h2>
            <p className="text-xl text-gray-300 mb-12">
              Nutzen Sie unser Kontaktformular – wir melden uns innerhalb von 24 Stunden und beraten Sie unverbindlich.
            </p>
            
            <div className="flex flex-col sm:flex-row gap-6 justify-center">
              <Link to={getWhyFutureLevelPath()}>
                <Button 
                  className="group neo-button relative overflow-hidden text-base flex items-center gap-3 px-8 py-7 glow-effect"
                >
                  <MessageSquare className="w-5 h-5" />
                  Warum Future Level
                  <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform duration-300" />
                  <span className="absolute inset-0 bg-gradient-to-r from-purple-600/0 via-purple-600/30 to-purple-600/0 opacity-0 group-hover:opacity-100 transition-opacity duration-500 -z-10"></span>
                </Button>
              </Link>
            </div>
          </div>
          
          {/* Social proof with improved text contrast */}
          <div className="mt-16 py-6 px-6 bg-[#111116]/50 backdrop-blur-sm border border-purple-900/20 rounded-xl">
            <div className="flex flex-col items-center">
              <div className="flex space-x-1 mb-4">
                {[...Array(5)].map((_, i) => (
                  <svg key={i} className="w-5 h-5 text-yellow-400" fill="currentColor" viewBox="0 0 20 20">
                    <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"></path>
                  </svg>
                ))}
              </div>
              <p className="text-white italic mb-4 max-w-lg">
                "Die KI-Videos von Future Level haben unseren Social-Media-Auftritt komplett verändert. Die Engagement-Raten sind durch die Decke gegangen!"
              </p>
              <p className="text-gray-400 text-sm">
                – Marco B., Marketing Director bei Swiss Beauty Brand
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CtaSection;
